import React from "react";
import whatsappIcon from "../assets/whatsapp-icon.svg";
import { openSupportWhatsApp } from "../constants/support";

export default function SupportChip({ onClick = null, className = "" }) {
  const handleClick = onClick || openSupportWhatsApp;

  return (
    <button
      onClick={handleClick}
      className={`bg-black border border-white/80 px-3 py-2 flex items-center gap-2 text-sm hover:bg-black/80 text-white rounded-[3px] ${className}`}
    >
      <img
        src={whatsappIcon}
        alt="Support"
        className="w-4 h-4"
        style={{ filter: 'brightness(0) invert(1)' }}
      />
      <span>Support</span>
    </button>
  );
}
